import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loggedIn: false,
    pageTitle: "",
    pageIntroText: "",
    showSidebar: false,
    db: {},
    uid: "",
    loading: false,
    painEntries: []
  },

  mutations: {
    modifyLoggedIn(state, loggedIn) {
      state.loggedIn = loggedIn;
    },
    changePageTitle(state, title) {
      state.pageTitle = title;
    },
    changePageIntroText(state, text) {
      state.pageIntroText = text;
    },
    showSidebar(state) {
      state.showSidebar = true;
    },
    hideSidebar(state) {
      state.showSidebar = false;
    },
    setDB(state, db) {
      state.db = db;
    },
    setUID(state, uid) {
      state.uid = uid;
    },
    modifyLoading(state, loading) {
      state.loading = loading;
    },
    addPainEntry(state, entry) {
      state.painEntries.push(entry);
    },
    clearPainEntries(state) {
      state.painEntries = [];
    }
  },

  getters: {
    getLoggedInStatus: state => state.loggedIn,
    getPageTitle: state => state.pageTitle,
    getPageIntroText: state => state.pageIntroText,
    getSidebarStatus: state => state.showSidebar,
    getDB: state => state.db,
    getUID: state => state.uid,
    getLoading: state => state.loading,
    getPainEntries: state => state.painEntries
  }
});
